import { Link } from '@/components/Link';
import { Paths } from '@/utils/paths';

export type NetworksProps = {
  store: AdaptedStore<true>;
  displayNetworks: AdaptedStore<true>['networks'];
  content: StoreProfilePageContent;
};

export function Networks({ store, displayNetworks, content }: NetworksProps) {
  return (
    <div className="flex w-full flex-col items-start">
      <h2 className="text-xl">{content.profile.acceptedNetworks}</h2>

      <div className="flex w-full flex-row flex-wrap">
        {store.settings.marketplacesEnabled && (
          <span className="ring-network-primary mt-4 mr-4 rounded-lg bg-white px-2 py-1 text-sm whitespace-nowrap ring-1">
            {`${store.name} ${content.profile.giftcard}`}
          </span>
        )}

        {displayNetworks.map(network => (
          <span
            key={network.id}
            className="ring-network-primary mt-4 mr-4 rounded-lg bg-white px-2 py-1 text-sm whitespace-nowrap ring-1"
          >
            <Link href={`${Paths.NETWORK_GIFTCARDS}/${network.slug}`}>
              {network.name}
            </Link>
          </span>
        ))}
      </div>
    </div>
  );
}
